import { API_V2 } from '@front-app/services/api';
import { LinkContentItem, LinkContentResponse } from '@front-app/services/GroupsApi/DiscussionModel';
import { parseLinkContentResponse } from '@front-app/services/parse';

export interface CreateLinkRequest {
	name: string;
	description: string;
	url: string;
	category: string[];
	messageId?: string;
}

export interface UpdateLinkRequest {
	name: string;
	description: string;
	categories: string[];
}

export function getLink(groupId: string, linkId: string): Promise<LinkContentItem> {
	return API_V2.get(`groups/${groupId}/link/${linkId}`)
		.then(({ data }) => data as LinkContentResponse)
		.then(parseLinkContentResponse);
}

export function addLink(groupId: string, link: CreateLinkRequest): Promise<LinkContentItem> {
	return API_V2.post(`groups/${groupId}/link`, link)
		.then(({ data }) => data as LinkContentResponse)
		.then(parseLinkContentResponse);
}

export function editLink(groupId: string, linkId: string, link: UpdateLinkRequest): Promise<LinkContentItem> {
	return API_V2.put(`groups/${groupId}/link/${linkId}`, link)
		.then(({ data }) => data as LinkContentResponse)
		.then(parseLinkContentResponse);
}

export function deleteLink(groupId: string, linkId: string): Promise<void> {
	return API_V2.delete(`groups/${groupId}/link/${linkId}`);
}
